(function(window, document, $, undefined){
  // theme park filter panel menu trigger
  $('.sr-filter-menu-trigger, .sr-filter-menu-overlay, .close-sr-filter-menu').click(function(e) {
    // console.log('sdfsdf');
    e.preventDefault();
    toggle_sr_filter_menu();
  });

  function toggle_sr_filter_menu(){
    var menu = $('.sr-filter-menu');
    var overlay = $('.sr-filter-menu-overlay');
    var menuWidth = menu.outerWidth();

    if(!menu.hasClass('open')){
      //open
      menu.addClass('open');
      TweenMax.to(overlay,0.5,{autoAlpha:1,ease:Power3.easeOut});
      TweenMax.to(menu,0.5,{right:0,ease:Power3.easeOut});
    } else {
      //close
      TweenMax.to(overlay,0.5,{autoAlpha:0,ease:Power3.easeOut});
      TweenMax.to(menu,0.5,{right:-menuWidth,ease:Power3.easeOut,onComplete:function(){
        menu.removeClass('open');
      }});    
    }
  }







  // Add body class loading for ajax calls
  $(document).on("sf:ajaxstart", ".searchandfilter", function(){
      $('body').addClass('searchandfilter-loading');
    // console.log("ajax start");
  });
  $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
      $('body').removeClass('searchandfilter-loading');
    // console.log("ajax complete");
  });



  // THEME PARK FILTER FUNCTIONS.....

  // theme-park category selects
  $('.category-select a').click(function(e) {
    e.preventDefault();
    console.log('cat select');
    if($('body').hasClass('searchandfilter-loading')) return false;

    $('.category-select a').removeClass('active');
    $(this).addClass('active');

    var cat_slug = $(this).attr('data-sf-category');

    var sf_category_select = $('select[name="_sft_category[]"]');
    var sf_category_checkboxes = $('input[name="_sft_category[]"]');

    if(sf_category_select){
      var options = sf_category_select.find('option');
      var matchedOptionIndex = false;
      for (var i = 0; i < options.length; i++) {
        if(options[i].value==cat_slug) matchedOptionIndex = i;
      }
      $('select[name="_sft_category[]"]').prop('selectedIndex',matchedOptionIndex).trigger('change');
    }

    if(sf_category_checkboxes){
      // $('input[name="_sft_category[]"]').prop('checked',false);
      var matchedOptionIndex = false;
      for (var j = 0; j < sf_category_checkboxes.length; j++) {
        $('input[name="_sft_category[]"]').eq(j).prop('checked',false).trigger('change');
        if(sf_category_checkboxes[j].value==cat_slug) {
          matchedOptionIndex = i;
          $('input[name="_sft_category[]"]').eq(j).prop('checked',true).trigger('change');
        } else {
        }
      }
    }

  });




  $('.category-select-vacancies a').click(function(e) {
    e.preventDefault();
    console.log('cat select');
    if($('body').hasClass('searchandfilter-loading')) return false;

    $('.category-select-vacancies a').removeClass('active');
    $(this).addClass('active');

    var cat_slug = $(this).attr('data-sf-category');

    var sf_category_select = $('select[name="_sft_vacancy-category[]"]');
    var sf_category_checkboxes = $('input[name="_sft_vacancy-category[]"]');

    if(sf_category_select){
      var options = sf_category_select.find('option');
      var matchedOptionIndex = false;
      for (var i = 0; i < options.length; i++) {
        if(options[i].value==cat_slug) matchedOptionIndex = i;
      }
      // console.log('options',options);
      // console.log('matchedOptionIndex',matchedOptionIndex);
      $('select[name="_sft_vacancy-category[]"]').prop('selectedIndex',matchedOptionIndex).trigger('change');
    }

    // if(sf_category_checkboxes){
    //   // $('input[name="_sft_vacancy-category[]"]').prop('checked',false);
    //   var matchedOptionIndex = false;
    //   for (var j = 0; j < sf_category_checkboxes.length; j++) {
    //     $('input[name="_sft_vacancy-category[]"]').eq(j).prop('checked',false).trigger('change');
    //     if(sf_category_checkboxes[j].value==cat_slug) {
    //       matchedOptionIndex = i;
    //       $('input[name="_sft_vacancy-category[]"]').eq(j).prop('checked',true).trigger('change');
    //     } else {
    //     }
    //   }
    // }

  });



  // https://gist.github.com/rmorse/b157004c68870dbd9fb9

  // HOOK INTO AJAX TO CHANGE THE CAT SELECTS
  $(document).on("sf:ajaxstart", ".searchandfilter", function(){

    // console.log("ajax start");
    // var sf_category_select = $('#search-filter-form-3341 select[name="_sft_category[]"]');
    var sf_category_select = $('select[name="_sft_category[]"]');
    if(sf_category_select.length) {
      var selected = sf_category_select.val();
      // console.log(selected);
      $('.category-select a').removeClass('active');
      var newCat = $('.category-select a[data-sf-category="'+selected+'"]');
      if(newCat.length){
        newCat.addClass('active');
      } else {
        $('.category-select a[data-sf-category="*"]').addClass('active');
      }
    }
  });








})(window, document, jQuery);
